import React from 'react'
import './style.css'

export default function YouTubeVideo({videoId}) {
    if(!videoId) {
        return null
    }

    const embedUrl = `https://www.youtube.com/embed/${videoId}`

    return (
        <div className={"youtube-wrap"}>
            <iframe
                src={embedUrl}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen={true}
            />
        </div>
    )
}
